var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4671_77454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 54.9879C110 67.9206 105.536 79.8158 98.0807 89.2016C87.9952 101.869 72.4567 110 55.0121 110C37.5674 110 22.0048 101.869 11.9434 89.2016C4.4637 79.8158 0 67.9206 0 54.9879C0 42.0553 4.4637 30.1843 11.9193 20.7984C15.1524 16.7449 18.9406 13.1257 23.1871 10.1097C32.1869 3.73986 43.1652 0 54.9879 0C66.8348 0 77.8131 3.73986 86.7888 10.1097C91.0353 13.1257 94.8234 16.7449 98.0566 20.7984C105.536 30.1843 110 42.0794 110 54.9879Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5999 30.0013V97.1011C94.5999 101.201 91.3319 104.5 87.271 104.5H22.7288C18.6679 104.5 15.3999 101.201 15.3999 97.1011V12.8989C15.3999 8.79919 18.6679 5.5 22.7288 5.5H68.7926C69.1771 5.5 69.5615 5.52426 69.922 5.59703C71.3397 5.81536 72.6613 6.47035 73.7426 7.46496L92.221 24.5916C93.3264 25.6105 94.0713 26.9447 94.4077 28.4003C94.5518 28.9097 94.5999 29.4434 94.5999 30.0013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 15.4004H27.5V18.7004H59.4V15.4004Z",
    fill: "#D9E4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 23.0996H27.5V26.3996H46.2V23.0996Z",
    fill: "#D9E4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5999 28.6H73.9147C71.9673 28.6 70.3999 26.9764 70.3999 24.9591V5.5C71.8011 5.72141 73.1073 6.38562 74.176 7.39425L92.4388 24.7623C93.5312 25.7955 94.2912 27.1486 94.5999 28.6Z",
    fill: "url(#paint0_linear_4671_77454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8253 89.1008H34.1845C27.3131 89.1008 23.0398 81.6187 26.5604 75.6913L47.393 40.637C50.8408 34.8554 59.2175 34.8554 62.6411 40.637L83.4494 75.6913C86.9458 81.5944 82.6967 89.1008 75.8253 89.1008Z",
    fill: "url(#paint1_linear_4671_77454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2997 54.2273V67.8743C58.2997 68.6589 57.6247 69.3008 56.7997 69.3008H53.1997C52.3747 69.3008 51.6997 68.6589 51.6997 67.8743V54.2273C51.6997 53.4427 52.3747 52.8008 53.1997 52.8008H56.7997C57.6247 52.8008 58.2997 53.4427 58.2997 54.2273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2997 75.0762V77.8262C58.2997 78.5824 57.6247 79.2012 56.7997 79.2012H53.1997C52.3747 79.2012 51.6997 78.5824 51.6997 77.8262V75.0762C51.6997 74.3199 52.3747 73.7012 53.1997 73.7012H56.7997C57.6247 73.7012 58.2997 74.297 58.2997 75.0762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00938 9.90255C1.9017 9.8323 0.110161 11.4833 0.00477701 13.591C-0.100607 15.6987 1.55041 17.4902 3.69323 17.5956C5.80092 17.701 7.62758 16.05 7.69784 13.9423C7.76809 11.8346 6.11707 10.0079 4.00938 9.90255Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87922 2.20212C7.67677 2.13889 6.63254 3.11887 6.60089 4.32014C6.56925 5.52141 7.48691 6.56462 8.68936 6.59623C9.89181 6.65946 10.936 5.71109 10.9993 4.50982C11.031 3.27694 10.0817 2.23373 8.87922 2.20212Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.679 98.0029C106.478 97.9397 105.435 98.9197 105.403 100.121C105.34 101.322 106.289 102.365 107.49 102.397C108.691 102.46 109.734 101.512 109.797 100.311C109.861 99.1093 108.912 98.0661 107.679 98.0029Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.138 103.703C100.489 103.621 99.0862 104.934 99.0037 106.576C98.9212 108.218 100.214 109.613 101.864 109.695C103.513 109.778 104.943 108.491 104.998 106.85C105.053 105.208 103.788 103.758 102.138 103.703Z",
    fill: "#E4F0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4671_77454",
    x1: 70.4052,
    y1: 17.0548,
    x2: 94.6085,
    y2: 17.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4671_77454",
    x1: 40.4798,
    y1: 75.9008,
    x2: 67.3113,
    y2: 38.7979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4671_77454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalAttention);
export default __webpack_public_path__ + "static/media/modal-attention.3ed345552e359b759c1d17ffb77c50b8.svg";
export { ForwardRef as ReactComponent };